import Box from "@material-ui/core/Box";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
export const getMasterColumns = (editData) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editData(row);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "MODULE_NAME",
      text: "Module Name",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "MODULE_GROUP",
      text: "Group Name",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SEQUENCE",
      text: "Sequence",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "MODULE_DESC",
      text: "Module Description",
      sort: true,
      headerAlign: 'center',
    },
  ];
  return columns;
};
